import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TabPanel from "../tabPanel/tabPanel";
import LmstableData from "../../../../library/custom/lmstableData/lmstableData";
import "./coursescormList.scss";
import { useSelector, useDispatch } from "react-redux";
import { COLUMNS_SCORM_COURSES_VIEW } from "../../courseConstant";
import TableRowAction from "../../../../library/custom/gridTable/TableRowAction";
import { useNavigate } from "react-router-dom";
import * as lmsAction from "../../../../redux/actions/lmsAction";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {
  PAGE_SIZE,
  ORG_ID,
  USER_ID,
  API_STATUS,
  USER_TYPE,
} from "../../../../constant/constant";
import { InactiveClient } from "../../../../utils/helper";
import FilterCommonStatusSelect from "../../../admin/shared/FilterCommonStatusSelect";
import FilterListIcon from "@mui/icons-material/FilterList";
import Buttons from "../../../../library/custom/button/Button";
import { RadioGroup } from "@mui/material";
import RadioButton from "../../../../library/custom/radioButton/RadioButton";
import SearchAutoComplete from "../../../../library/custom/searchAutoComplete/SearchAutoComplete";
import { useDebounce } from "../../../../utils/useDebounceSearch";
import DialogBox from "../../../../library/common/DialogBox";
import downloadIcon from "../../../../assets/downloadIcon.svg";

const CoursescormList = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const getCoursesListData = props?.getCoursesListData;
  const setcheckcoursestatus = props?.setcheckcoursestatus;
  const getStatusCheckCoursecompleted = props?.getStatusCheckCoursecompleted;
  const checkcoursestatus = props?.checkcoursestatus;
  const completeCourseStatusResult = props?.completeCourseStatusResult;
  const setisSubmitAssign = props?.setisSubmitAssign;
  const isSubmitAssign = props?.isSubmitAssign;
  const allUsers = props?.allUsers;
  const userGroups = props?.userGroups;
  const assigncourseStatus = props?.assigncourseStatus;
  const setisdisable = props?.setisdisable;
  const isdisable = props?.isdisable;
  const initialTabValue = props?.defaultTabValue ?? 0;
  const courseListData = props?.courseListData;
  const categoryListData = props?.categoryListData;
  const onSearch = props?.onSearch;
  const { isLoading } = useSelector((state) => state.getCoursesList);
  const handleAllGroupSearch = props?.handleAllGroupSearch;

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [value, setValue] = React.useState(initialTabValue);
  const [status, setStatus] = useState(initialTabValue);
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState();
  const [isTableLoading, setisTableLoading] = useState(false);
  const [activeInActive, setActiveInActive] = useState({
    ACTIVE: false,
    INACTIVE: false,
  });
  const [statuccheck, setStatuccheck] = useState("1");
  const [userOrGroupId, setUserOrGroupId] = useState("");
  const [isassignName, setIsassignName] = useState(false);
  const [usersValue, setUsersValue] = useState();
  const [usersGroupValue, setUsersGroupValue] = useState();
  const [courseid, setCourseid] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [search, setSearch] = useState("");
  const [Reassignbtndisable, setReassignbtndisable] = useState(false);
  const isScormFirstRender = React.useRef(true);
  const autoCompUser = useRef(null);
  const autoCompGroup = useRef(null);
  const debouncedSearch = useDebounce(search, 500);
  //const [dataConfirm, setDataConfirm] = useState(null);
  const [price, setPrice] = useState(null);

  /** ============================================================state and use selctor selected================================================================ */
  const handlecheckbtn = (e, value) => {
    setStatuccheck(e.target.value);
    setUserOrGroupId("");
    setIsassignName(false);
    setUsersValue({ key: "", value: "" });
    setUsersGroupValue({ key: "", value: "" });
  };

  const handleClose1 = () => props?.setOpens(false);

  const handleActiveInActiveChange = (event) => {
    const { value } = event.target;
    setActiveInActive((prevState) => {
      if (!prevState) return { ACTIVE: false, INACTIVE: false };
      const newState = {
        ...prevState,
        [value]: !prevState[value],
      };
      let status = "";
      if (newState.ACTIVE && !newState.INACTIVE) {
        status = true;
      } else if (!newState.ACTIVE && newState.INACTIVE) {
        status = false;
      }
      if (!newState.ACTIVE && !newState.INACTIVE) {
        dispatch(lmsAction.clearCategoryList());
      } else {
        const data = {
          pageNumber: 1,
          isGlobal: "",
          status: status,
        };
        props?.getategoryListData(data);
      }

      return newState;
    });
  };

  const handleClose = (event) => {
    event?.currentTarget.type === "button"
      ? setAnchorEl(event.currentTarget)
      : setAnchorEl(null);
  };

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event?.target?.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
  };

  const handleViewOnClick = (courseId, price) => {
    props?.setDataConfirm(null);
    setUsersValue({ key: "", value: "" });
    setStatuccheck("1");
    props?.setOpens(true);
    setCourseid(courseId);
    setUserOrGroupId("");
    props?.setScromConfirmationOpen(false);
    setPrice(price);
    setUsersGroupValue({ key: "", value: "" });
  };

  const columns = React.useMemo(() => {
    const headers = [...COLUMNS_SCORM_COURSES_VIEW];
    headers.push({
      field: "",
      width: 75,
      sortable: false,
      disableClickEventBubbling: true,
      filterable: false,
      disableColumnMenu: true,
      headerClassName: "course-action-header",
      renderCell: (rows) => {
        return (
          <TableRowAction
            rows={rows}
            usingComp={"Course"}
            view
            viewLabel={"Assign Course"}
            viewOnClick={(row) => handleViewOnClick(row?.id, row?.price)}
          />
        );
      },
    });
    return headers;
  }, [courseListData, pageSize, navigate, isdisable]);

  const handlePagignation = (newPage) => {
    setPage(newPage);
    getCoursesListData({
      pageNumber: newPage + 1,
      pageSize: pageSize,
      search: debouncedSearch,
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
      isScorm: true,
    });
  };
  const handleSearch = () => {
    setPage(0);
    setPageSize(PAGE_SIZE);
    const data = {
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      search: search ? search : "",
      catIds: selectedValue ? selectedValue : "",
      statusId: parseInt(value) === 0 ? 2 : parseInt(value) === 2 ? "" : 1,
      userId: parseInt(USER_ID()),
      orgId: parseInt(ORG_ID()),
      organisationId: ORG_ID(),
      status: value ? value : "",
      isScorm: true,
    };
    setAnchorEl(null);
    getCoursesListData(data);
  };
  const onChangeCategoryType = (item) => {
    setSelectedValue(item?.target?.value);
  };

  const handleClear = (item) => {
    setSelectedValue("");
    setSearch("");
    setPage(0);
    setPageSize(PAGE_SIZE);
    getCoursesListData({
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      search: "",
      catIds: "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
      isScorm: true,
    });
    setAnchorEl(null);
    setOpen(false);

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    getCoursesListData({
      pageNumber: 1,
      pageSize: newPazeSize,
      search: search ? search : "",
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
      isScorm: true,
    });
  };
  // Edit Global content Course

  const onChangeUsers = (e) => {
    props?.setUsersGroup(e);
    setUsersValue({ key: e?.key ?? "", value: e?.value ?? "" });
    setUsersGroupValue({ key: e?.key ?? "", value: e?.value ?? "" });
    if (e == null) {
      setUserOrGroupId("");
    } else {
      setUserOrGroupId(e.key);
      setIsassignName(false);
    }
  };
  function mappedData() {
    let errors = false;
    if (userOrGroupId?.length === 0) {
      setIsassignName(true);
      errors = true;
    }
    if (errors) {
      return false;
    }
    let data;
    data = {
      userType: parseInt(statuccheck),
      courseId: courseid,
      // userOrGroupId: 140,
      userOrGroupId: parseInt(userOrGroupId), // munsafa 2560
      createdBy: parseInt(USER_ID()),
      orgId: parseInt(ORG_ID()),
    };
    return data;
  }
  const handleClickAdd = (e) => {
    if (InactiveClient()) return;
    setisSubmitAssign(true);
    const data = mappedData();
    props?.setDataConfirm(data);
    if (!data) {
    } else {
      props?.setIsSubmit(true);

      if (statuccheck === "0") {
        getStatusCheckCoursecompleted(data); // Use effect call and Assing api call Indivuial
      } else if (statuccheck === "1") {
        props?.setScromConfirmationOpen(true);
        // dispatch(lmsAction.assignCourse(data)); //Api call direct Group Assign
      }
    }
  };
  const cancelreassign = (e) => {
    setcheckcoursestatus(false);
  };

  const handleClickAddReassign = (e) => {
    if (InactiveClient()) return;
    setReassignbtndisable(true);
    props?.setScromConfirmationOpen(true);
    let data;
    data = {
      userType: parseInt(statuccheck),
      courseId: courseid,
      userOrGroupId: parseInt(userOrGroupId),
      createdBy: USER_ID(),
      orgId: ORG_ID(),
      reAssign: true,
    };
    props?.setDataConfirm(data);
    // dispatch(lmsAction.assignCourse(data)); //Api call Resign call Indiviual
  };

  useEffect(() => {
    // indiviual Submit
    if (
      checkcoursestatus === false &&
      props?.completeCourseStatusStatus === API_STATUS.SUCCESS &&
      props?.completeCourseStatusResult?.length === 0 &&
      isSubmitAssign
    ) {
      const data = mappedData();
      if (data) {
        data.reAssign = false;
      }
      props?.setScromConfirmationOpen(true);
      props?.setDataConfirm(data);
      //dispatch(lmsAction.assignCourse(data)); // Api call Assign  Indiduial
    }
  }, [props?.completeCourseStatusResult, props?.completeCourseStatusStatus]);

  useEffect(() => {
    setValue(initialTabValue);
    setStatus(initialTabValue);
  }, [initialTabValue]);
  const closeAssignPopup = () => {
    props?.setOpens(false);
    setcheckcoursestatus(false);
    setIsassignName(false);
    setUsersValue({ key: "", value: "" });
    setUsersGroupValue({ key: "", value: "" });
    setUserOrGroupId("");
    setisSubmitAssign(false);
    setReassignbtndisable(false);
  };
  useEffect(() => {
    if (assigncourseStatus === API_STATUS.SUCCESS) {
      setTimeout(() => {
        props?.setOpens(false);
        closeAssignPopup();
      }, 2000);
    }
    setUserOrGroupId("");
  }, [assigncourseStatus]);

  useEffect(() => {
    if (courseListData.status === API_STATUS.SUCCESS) {
      setisdisable(false);
    }
  }, [courseListData.status]);

  useEffect(() => {
    if (isScormFirstRender.current) {
      isScormFirstRender.current = false;
      return;
    }
    setPage(0);
    const data = {
      pageNumber: 1,
      pageSize: pageSize,
      search: debouncedSearch,
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
      isScorm: true,
    };
    getCoursesListData(data);
  }, [debouncedSearch]);

  const handleCloseScromConfirmation = () => {};

  const assignConfirm = () => {
    dispatch(lmsAction.assignCourse(props?.dataConfirm));
  };
  const sendEmail = () => {
    getCoursesListData({
      pageNumber: page + 1,
      pageSize: pageSize,
      search: search,
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: true,
      isScorm: true,
    });
  };
  useEffect(() => {
    if (props?.usersGroup && statuccheck == "1") {
      props?.getUserGroupDetail(props?.usersGroup?.key);
    }
  }, [props?.usersGroup]);
  return (
    <>
      <div className="couresList">
        <Modal
          open={props?.opens}
          onClose={handleClose1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              width: { xs: "95vw", sm: 500 },
              maxHeight: "90vh",
              overflowY: "auto",
              p: 3,
              fontFamily: "Lato",
              fontSize: "14px",
              fontWeight: 600,
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Grid mt={0} mb={1}>
              <div
                style={{
                  fontFamily: "lato",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
                className="ProcoreCompanyListHeading"
              >
                Assign Scorm Courses
              </div>
            </Grid>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <div className="assignPopDetail">
                <div className="title">User Type</div>
                <div className="innerauto">
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    gap={5}
                    className="radioGroup"
                  >
                    <RadioButton
                      checked={statuccheck === "1" ? true : false}
                      value="1"
                      label="Group"
                      disabled={false}
                      onChange={(e, value) => handlecheckbtn(e, value)}
                    ></RadioButton>

                    <RadioButton
                      checked={statuccheck === "0" ? true : false}
                      value="0"
                      label="Individual"
                      disabled={false}
                      onChange={(e, value) => handlecheckbtn(e, value)}
                    ></RadioButton>
                  </RadioGroup>

                  {statuccheck === "1" ? (
                    <>
                      <div className="searchauto">
                        <SearchAutoComplete
                          noOptionsTextMsg="No group"
                          isKeyValuePair={true}
                          optionsData={isLoading ? [] : userGroups ?? []}
                          typeOnchange={(event, value) =>
                            handleAllGroupSearch(event.target.value, 0, true)
                          }
                          isLoading={props?.isLoadingGroup}
                          onChange={(e, value) => onChangeUsers(value)}
                          autoCompClear={autoCompGroup}
                          value={usersGroupValue ? usersGroupValue : ""}
                        />
                      </div>
                      {isassignName ? (
                        <div className="show-error">
                          Please enter this required field
                        </div>
                      ) : (
                        ""
                      )}
                      <Grid container lg={12} mt={2} className="individualbtn">
                        <Buttons
                          variant="contained"
                          type="button"
                          name="btn"
                          label={"Assign"}
                          varientContained={true}
                          onClick={(e) => handleClickAdd(e)}
                          //  disabled={props?.isSubmit ? true : false}
                        ></Buttons>
                      </Grid>
                      {props.assignmsg ? (
                        <div className="success">
                          Scorm Course Assign successfully
                        </div>
                      ) : null}
                    </>
                  ) : (
                    <>
                      <SearchAutoComplete
                        name="userName"
                        optionsData={
                          props?.AlluserisLoading ? [] : (allUsers ?? [])
                        }
                        isKeyValuePair={true}
                        typeOnchange={(event, value) =>
                          onSearch(event.target.value, USER_TYPE.ALL)
                        }
                        isLoading={props?.AlluserisLoading}
                        onChange={(e, value) => onChangeUsers(value)}
                        autoCompClear={autoCompUser}
                        value={usersValue ? usersValue : ""}
                      />
                      {isassignName ? (
                        <div className="show-error">
                          Please enter this required field
                        </div>
                      ) : (
                        ""
                      )}
                      {checkcoursestatus === true &&
                      completeCourseStatusResult?.length > 0 ? (
                        <div className="errorMsg">
                          This course has been completed by the assigned user.
                          Do you want to re-assign this course ?
                        </div>
                      ) : (
                        ""
                      )}

                      <Grid container lg={12} mt={2} className="individualbtn">
                        {checkcoursestatus === false && (
                          <Buttons
                            variant="contained"
                            type="button"
                            name="btn"
                            label={"Assign"}
                            varientContained={true}
                            onClick={(e) => handleClickAdd(e)}
                            //disabled={props?.isSubmit ? true : false}
                          ></Buttons>
                        )}
                        {checkcoursestatus && (
                          <>
                            {" "}
                            <Buttons
                              varientText={true}
                              label="Cancel"
                              onClick={(e) => cancelreassign(e)}
                            />
                            <Buttons
                              variant="contained"
                              type="button"
                              name="btn"
                              label={"Apply"}
                              varientContained={true}
                              onClick={(e) => handleClickAddReassign(e)}
                              disabled={Reassignbtndisable ? true : false}
                            ></Buttons>
                          </>
                        )}
                      </Grid>

                      {props.assignmsg ? (
                        <div className="success">
                          Scorm Course Assign successfully
                        </div>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
            </Typography>
          </Box>
        </Modal>
        <Modal
          open={props?.scromConfirmationOpen}
          onClose={handleCloseScromConfirmation}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <DialogBox
            open={props?.scromConfirmationOpen}
            rows={[]}
            header={"Are you sure you want to Assign this Course?"}
            handleChangeUserToNonUser={assignConfirm}
            handleCloseModal={() => props?.setScromConfirmationOpen(false)}
            content={"Each seat will be billed upon assignment"}
            view
            deleteView={false}
            UserToNonUserView={false}
            isAssingScromCourse={true}
            price={price}
            groupUserCount={props?.groupUserCount}
            userType={statuccheck}
          />
        </Modal>

        <Grid container>
          <Grid lg={7} xs={12}>
            <div className="rightFilter lmsDownloadData">
              {" "}
              <div className="div-download-email-right" onClick={sendEmail}>
                <span>
                  <img
                    src={downloadIcon}
                    className="DownLoadLogo"
                    alt="DownLoad Logo"
                  />
                </span>
                Download Data
              </div>
            </div>
          </Grid>
          <Grid lg={5} xs={12}>
            <div className="rightFilter lmsDownloadData">
              <div className="filtertoolboxscorm lmsCls">
                <div className="filter_of_caselisttoolBox">
                  <div className="searchcaseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          placeholder="Search"
                          type="text"
                          value={search}
                          className=""
                          onChange={handleautoSearch}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>

                  <div className="filter_btn">
                    <button
                      aria-describedby={id}
                      variant="contained"
                      type="button"
                      name="btn"
                      onClick={(e) => handleClick(e)}
                    >
                      <FilterListIcon id="icn" /> Filters
                    </button>
                    <FilterCommonStatusSelect
                      id={id}
                      open={open1}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      handleApply={handleSearch}
                      handleClear={handleClear}
                      filterDate={false}
                      filterSelect
                      categoryType={categoryListData?.categoryList ?? []}
                      categoryOnChanges={onChangeCategoryType}
                      category={selectedValue}
                      filterStatus={false}
                      resetBtn={true}
                      label={"Category"}
                      activeInActive={activeInActive}
                      setActiveInActive={setActiveInActive}
                      handleActiveInActiveChange={handleActiveInActiveChange}
                      statusCheckbox={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container>
          <TabPanel className="tabPanel" value={value} index={0}>
            {isTableLoading ? (
              ""
            ) : (
              <LmstableData
                courseListDataAll={courseListData}
                onPageChange={handlePagignation}
                page={page}
                isLoading={isLoading}
                columns={columns}
                handlePageSizeChange={handlePageSizeChange}
                pageSize={pageSize}
                tableClass={props.tableClass}
              />
            )}
          </TabPanel>
        </Grid>
      </div>
    </>
  );
};

export default CoursescormList;
